import connectionProxy from './connectionProxy'

export const getAvailableReports = areaId =>
  connectionProxy.http.get(
    `/estoque_report/disponiveis?area_id=${areaId}`
  )

export const getReportList = (areaId, month, year) =>
  connectionProxy.http.get(
    `/estoque_report?area_id=${areaId}&month=${month}&year=${year}`
  )

export const getInvoiceList = (areaId, productId, month, year) =>
  connectionProxy.http.get(
    `/estoque_report/notas_fiscais?area_id=${areaId}&product_id=${productId}&month=${month}&year=${year}`
  )

export const responsibleApproveMonth = ({ areaId, year, month, type }) =>
  connectionProxy.http.post(
    `/report_estoque_atual/aprovar?area_id=${areaId}&year=${year}&month=${month}&type=${type}`
  )

export const closeMonth = ({ areaId, year, month }) =>
  connectionProxy.http.post(
    `/estoque_report?area_id=${areaId}&year=${year}&month=${month}`
  )

export const openMonth = ({ areaId, year, month }) =>
  connectionProxy.http.delete(
    `/estoque_report?area_id=${areaId}&year=${year}&month=${month}`
  )



// WEBPACK FOOTER //
// ./src/api/report.js